import { render, staticRenderFns } from "./GroupContactsPopup.vue?vue&type=template&id=d2ec3498&"
import script from "./GroupContactsPopup.vue?vue&type=script&lang=js&"
export * from "./GroupContactsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports